export default __webpack_public_path__ + "static/media/angry-face.916259a3.svg";